import React from "react";
import ProfilePageTemplate from "../shared/ProfilePageTemplate";
import OrganizationStructure from "../shared/OrganizationStructure";

const ProtocolContent: React.FC = () => {
  const OverviewContent = () => (
    <div className="p-8">
      <div className="prose prose-lg max-w-none">
        <h2 className="text-2xl font-bold mb-4">Bagian Protokol</h2>
        <p className="text-base-content/70 leading-relaxed mb-6">
          Bagprot bertugas menyelenggarakan keprotokoleran Internasional Polri,
          pengelolaan fasilitas layanan kepada Perwakilan Negara Asing (PNA) dan
          Organisasi Internasional (OI) yang memiliki hubungan kerja sama dengan
          Polri, dan pelayanan fasilitas luar negeri personel Polri.
        </p>

        <h3 className="text-xl font-bold mb-4">Fungsi</h3>
        <p className="text-base-content/70 mb-4">
          Dalam melaksanakan tugas, Bagprot menyelenggarakan fungsi:
        </p>
        <ol className="list-decimal list-inside space-y-3 text-base-content/70">
          <li className="leading-relaxed">
            penyusunan, koordinasi dan pemberian bimbingan teknis serta
            pengawasan di bidang keprotokoleran, kekonsuleran internasional;
          </li>
          <li className="leading-relaxed">
            pelayanan fasilitas protokoler pejabat PNA dan OI yang berhubungan
            dengan Polri; dan
          </li>
          <li className="leading-relaxed">
            pelayanan fasilitas personel Polri yang akan melaksanakan tugas ke
            luar negeri;
          </li>
        </ol>
      </div>
    </div>
  );

  const organizationUnits = [
    {
      name: "Subbagian Operasional Protokol",
      abbreviation: "Subbagopsprot",
      description:
        "Menyelenggarakan operasional keprotokoleran internasional Polri",
    },
    {
      name: "Subbagian Fasilitas Pelayanan PNA dan OI",
      abbreviation: "Subbagfasyan PNA dan OI",
      description:
        "Mengelola fasilitas layanan kepada Perwakilan Negara Asing dan Organisasi Internasional",
    },
    {
      name: "Subbagian Fasilitas Pelayanan Luar Negeri Personel Polri",
      abbreviation: "Subbagfasyanlugripol",
      description:
        "Melayani fasilitas personel Polri yang akan melaksanakan tugas ke luar negeri",
    },
    {
      name: "Urusan Administrasi",
      abbreviation: "Urmin",
      description: "Mengelola administrasi bagian protokol",
    },
  ];

  const tabs = [
    {
      id: "overview",
      label: "Gambaran Umum",
      icon: "📋",
      component: <OverviewContent />,
    },
    {
      id: "structure",
      label: "Struktur Organisasi",
      icon: "🏗️",
      component: (
        <OrganizationStructure
          mainTitle="Struktur Organisasi Bagian Protokol"
          mainDescription="Dalam melaksanakan tugas, Bagprot dibantu oleh 4 (empat) unit kerja:"
          units={organizationUnits}
        />
      ),
    },
  ];

  return (
    <ProfilePageTemplate
      title="Protokol"
      subtitle="Bagian Protokol Divhubinter Polri"
      icon="🤝"
      breadcrumbBase="Tentang"
      tabs={tabs}
      footerTitle="Bagian Protokol"
      footerDescription="Menyelenggarakan keprotokoleran internasional Polri dan pelayanan fasilitas kepada mitra internasional."
      footerStats={[
        { label: "Unit Kerja", value: "4" },
        { label: "Layanan", value: "3 Fungsi" },
        { label: "Cakupan", value: "Internasional" },
      ]}
    />
  );
};

export default ProtocolContent;
